/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
// eslint-disable-next-line no-use-before-define
import React, { ReactElement } from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import {
  IconButton, Grid, Typography, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactElementLike } from 'prop-types';

type _Dialog = DialogProps & {
    onHide?: any;
    hide: any;
    open: boolean;
    title: any;
    iconTitle?: ReactElementLike;
    children?: ReactElementLike;
    actions?: string;
}

export default function Modal({
  onHide, hide, open, title, children, actions,
  iconTitle, ...rest
}:_Dialog) {
  function handleClose() {
    if (!onHide) {
      hide();
      console.log('hide');
    } else {
      onHide();
      hide();
    }
  };

  return (
    <div>
      <Dialog open={open} onClose={() => handleClose()} aria-labelledby="form-dialog-title" sx={{ zIndex: 99999999 }} {...rest}>
        <DialogTitle
          id="form-dialog-title"
        //  style={{ marginTop: '30px' }}
        >
          <Grid container>
            <Grid item xs={11}>
              <Box sx={{ display: 'flex' }}>
                <Typography variant="h5">
                  { title }
                </Typography>
                { iconTitle }
              </Box>
            </Grid>
            <Grid item xs={1} sx={{ display: 'flex' }}>
              <IconButton
                aria-label="delete"
                style={{
                  marginLeft: 'auto',
                  marginTop: '-5px',
                }}
                onClick={() => handleClose()}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    </div>
  );
}
